// extracted by css-extract-rspack-plugin
var _1 = "container-LNe9x6";
var _2 = "flag-z64cCe";
export { _1 as "container", _2 as "flag" }
